module.exports = __webpack_public_path__ + "static/media/centos.b69c4927.svg";